import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    SidebarVariant
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "stretch",
        flexDirection: "row",
        minHeight: 0,
        minWidth: 0,
        flexGrow: 1
    }
});

export const useStyles = ({
    variant,
    colors
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    variant: SidebarVariant;
}) => {
    const styles = {
        container: {
            backgroundColor: colors.content.container.default
        } as Mutable<ViewStyle>
    };

    if(variant === "inset") {
        styles.container.backgroundColor = colors.content.container.mid;
    }

    return styles;
};
export default stylesheet;
